type ErrorDefinition = {
  exceptionType?: string; // Exact match against parsed JSON
  expression?: string;    // Regex string to test against the raw message
  message: string;        // The user-friendly output
};

const ERROR_DICTIONARY: ErrorDefinition[] = [
  {
    exceptionType: 'org.hibernate.StaleObjectStateException',
    expression: 'StaleObjectStateException',
    message: "This record was updated by another user while you were editing. Please refresh to view the latest changes and try again."
  },
  {
    exceptionType: 'java.sql.SQLIntegrityConstraintViolationException',
    expression: 'ConstraintViolation',
    message: "This action cannot be completed because it conflicts with existing data (e.g., a duplicate name or ID)."
  },
  {
    expression: 'foreign key constraint fails',
    message: "This item cannot be deleted because it is currently being used by other records."
  }
];

export const parseErrorMessage = (rawMessage: string): string => {
  if (!rawMessage) return "An unknown error occurred.";

  let parsed: any = null;

  try {
    parsed = JSON.parse(rawMessage);
  } catch (e) {
    // Fails silently if it's a raw text error
  }

  // 1. Evaluate the dictionary rules
  for (const rule of ERROR_DICTIONARY) {
    // Check exact exceptionType first
    if (rule.exceptionType && parsed?.exceptionType === rule.exceptionType) {
      return rule.message;
    }
    
    // Fallback to testing the regex expression against the raw string
    if (rule.expression) {
      const regex = new RegExp(rule.expression, 'i'); // 'i' makes it case-insensitive
      if (regex.test(rawMessage)) {
        return rule.message;
      }
    }
  }

  // 2. Fallbacks if no dictionary rule matched
  if (parsed && typeof parsed === 'object') {
    return parsed.error || parsed.message || rawMessage;
  }

  return rawMessage;
};